import { useState } from "react";
import { ArrowLeft, TickCircle } from "iconsax-reactjs";
import { useNavigate } from "react-router-dom";

export default function ForgotPasswordScreen() {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (!email.trim()) return;

    setIsLoading(true);
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      // Handle password reset logic here
      console.log("Password reset requested for:", email);
    }, 1500);
  };

  const handleBackToLogin = () => {
    // Navigate back to login - replace with your routing logic
    navigate("/login");
  };

  return (
    <div className="auth-page">
      <img src="/assets/clockout-lockup-hero-2400.png" alt="Clock-out" className="auth-logo" />

      <div className="auth-card">
        {/* Icon */}
        <div className="flex justify-center mb-5">
          <div className="w-14 h-14 bg-[#FFC81E] rounded-[16px] flex items-center justify-center">
            <TickCircle className="w-7 h-7 text-[#1C1A14]" />
          </div>
        </div>

        {/* Main Content */}
        <div className="text-center mb-7">
          <h1 className="auth-title">Password reset</h1>
          <p className="auth-subtitle">
            Your password has been successfully reset. Click below to log in
            manually.
          </p>
        </div>

        <button onClick={handleSubmit} disabled={isLoading} className="auth-btn-primary">
          {isLoading ? (
              <>
                <div className="w-4 h-4 border-2 border-[#1C1A14] border-t-transparent rounded-full animate-spin"></div>
                Sending…
              </>
          ) : (
            "Continue"
          )}
        </button>

        <hr className="auth-divider" />
        <button
          onClick={handleBackToLogin}
          className="w-full text-sm text-[#4A4234] hover:text-[#1C1A14] font-semibold transition-colors flex items-center justify-center group"
        >
          <ArrowLeft className="w-4 h-4 mr-2 group-hover:-translate-x-1 transition-transform duration-200" />
          Back to sign in
        </button>
      </div>

      <p className="auth-footer">© {new Date().getFullYear()} Talk Nerdy To Me Consultancy Ltd. All rights reserved.</p>
    </div>
  );
}